import dynamic from "next/dynamic";
import { api } from "~/utils/api";
const ReactJson = dynamic(() => import("react-json-view"), { ssr: false });

export const DevPanelWorkflowOpenApi = ({
  serviceId,
}: {
  serviceId: string;
}) => {
  const [service] = api.service.getService.useSuspenseQuery({ id: serviceId });
  const activeImplementation = service?.activeImplementation;

  if (activeImplementation == null) {
    return <div>Cannot find service implementation</div>;
  }

  return (
    <div>
      <ReactJson
        src={activeImplementation.openapiSpec}
        style={{ fontSize: "12px", letterSpacing: 0, lineHeight: "1.1rem" }}
      />
    </div>
  );
};
